var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"title":_vm.pageTitle}},[_c('h3',[_vm._v("Menu is on the left")])])}
var staticRenderFns = []

export { render, staticRenderFns }